import { render } from "./customerInfo.vue?vue&type=template&id=39705cd4"
import script from "./customerInfo.vue?vue&type=script&lang=js"
export * from "./customerInfo.vue?vue&type=script&lang=js"

import "./customerInfo.vue?vue&type=style&index=0&id=39705cd4&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__